(function($) { 

  let $comments = $('#comments')
  if($comments.length) {  

    const $container = $('#content .ast-container')
    $comments = $comments.eq(0)
    $container.append($comments.remove())
    $comments.addClass('Visible')

    let $respondtitle = $comments.find('#respond #reply-title')
    if($respondtitle.length) { 

      $respondtitle = $respondtitle.eq(0)
      $respondtitle.after(
        '<div class="comment-questions">' + 
          __('Comment questions') + 
        '</div>'
      )
    } 
  }  

})(jQuery)